import React, { useState, useEffect } from 'react';
import { message, Spin, Modal } from 'antd';
import DataInputFeild from '../../components/DataInputFeild/DataInputFeild';
import Dropdown from '../../components/Dropdown/Dropdown';
import RadioButton from '../../components/RadioButton/RadioButton';
import TextArea from '../../components/TextArea/TestArea';
import DatePickesr from '../../components/DatePicker/DatePicker';
import FileuploadInput from '../../components/FileuploadInput/FileuploadInput';
import TimePicker from '../../components/TimePicker/TimePicker';
import { useNavigate } from 'react-router-dom';
import { editSession, getSessionById } from '../../redux/features/sessions/sessionActions';
import VideoUploadInput from '../../components/VideoUploadInput/VideoUplaodInput';
import LinkInput from '../../components/LinkInput/LinkInput';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { categoryOptions, languageOptions } from '../../utils/dataFile'
import { Link } from 'react-router-dom';
import { validateForm } from '../../utils/Validation/sessionConstraint';
import StatusRb from '../../components/RadioButton/StatusRb';
import { IoLogoYoutube } from "react-icons/io";
import ToggleBtn from '../../components/ToggleBtn/ToggleBtn';
import NumInput from '../../components/NumInput/NumInput';
import { PrivateAxiosInstance } from '../../services/createAxiosInstance';
import { URLs } from '../../constants/apiEndpoints';
import Table from '../../components/Table/Table';

function EditSession() {
    const [isLimitedBtn, setIsLimitedBtn] = useState(false);
    const [selectedCollectionId, setSelectedCollectionId] = useState('');
    const [url, setUrl] = useState('');
    const [currentPage, setCurrentPage] = useState(1); // Keep track of current page
    const [totalPages, setTotalPages] = useState(1);

    const [formData, setFormData] = useState({
        eventId: '',
        event_name: '',
        description: '',
        presenter: '',
        category: '',
        medium: '',
        date: null,
        startTime: '',
        endTime: '',
        files: null,
        status: '',
        YoutubeLinks: '',
        event_status: '',
        zoomLink: '',
        isLimited: false,
        numOfSeats: 0,
    });

    const [submitCollectionData, setSubmitCollectionData] = useState({
        eventCollectionId: '',
        eventCollectionName: '',
    })


    const [selectedTab, setSelectedTab] = useState("video");
    const [errors, setErrors] = useState({});
    const [isComplate, setIsComplate] = useState(false);
    const [isCollection, setIsCollection] = useState(false);
    const [collectionId, setCollectionId] = useState('');
    const [collectionData, setCollectionData] = useState('');
    const [allCollectionData, setAllCollectionData] = useState([]);
    const [isCollectionSection, setIsCollectionSection] = useState(false);
    const [loadingCollection, setLoadingCollection] = useState(false)



    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading } = useSelector((state) => state.session);

    useEffect(() => {
        const fetchData = async () => {
            try {

                const res = await dispatch(getSessionById({ eventId: id })).unwrap();
                const data = res?.event

                setFormData({
                    eventId: data?.eventId || '',
                    event_name: data?.event_name || '',
                    description: data?.description || '',
                    presenter: data?.presenter || '',
                    category: data?.category || '',
                    medium: data?.medium || '',
                    date: data?.date || null,
                    startTime: data?.startTime || '',
                    endTime: data?.endTime || '',
                    status: data?.status || '',
                    event_status: data?.event_status || '',
                    files: null,
                    zoomLink: data?.zoomLink || '',
                    isLimited: data?.isLimited || false,
                    numOfSeats: data?.numOfSeats || 0,
                    isCollection: data.isCollection || false,
                    eventCollectionId: data.eventCollectionId || '',

                });

                //set number input btn
                setIsLimitedBtn(data?.isLimited || false,)
                setIsCollection(data?.isCollection || false,)
                setCollectionId(data?.eventCollectionId)
                setIsCollectionSection(data?.isCollection || false,)
                //set youtube link

                setUrl(data?.video[0]?.videoName === 'YouTube' ? data?.video[0]?.url : '')

                if (data?.event_status === "complete") {
                    setIsComplate(true)
                }

                const collectionId = data?.eventCollectionId
                if (collectionId) {
                    await getCollectionData({ collectionId })
                }

                message.success('Fetched successfully!');

            } catch (err) {
                const errorMessage = err.response?.data?.message || 'Failed to fetch session';
                message.error(errorMessage);
            }
        };

        fetchData();
    }, [id]);



    const getCollectionData = async ({ collectionId }) => {
        const id = collectionId
        try {
            const url = `${URLs.GET_BY_SINGlE_COLLECTION}/${id}`;
            const res = await PrivateAxiosInstance.get(url);
            const status = res?.data?.success
            const data = res?.data?.event

            if (status) {
                setCollectionData(data)
            } else {
                message.error('No Collection data found');
            }
        } catch (err) {
            message.error('Something went wrong during fetching Collection data');
        } finally {
            // setGetLoading(false)
        }
    };


    const handleTabChange = (e) => {
        setSelectedTab(e.target.value);
    };

    const handleChange = ({ target: { name, value } }) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleEventStatusStatusChange = (value) => {
        setFormData((prevData) => ({
            ...prevData,
            event_status: value,
        }));
    };


    const handleStatusChange = (value) => {
        setFormData((prevData) => ({
            ...prevData,
            status: value,
        }));
    };

    const handleDropdownChange = (name) => (value) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleDateChange = (date) => {
        setFormData((prevData) => ({
            ...prevData,
            date,
        }));
    };

    const handleTimeChange = (time, type) => {
        setFormData((prevData) => ({
            ...prevData,
            [type]: time,
        }));
    };

    // Handle file change
    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData({
            ...formData,
            [name]: files[0], // handling single file upload
        });
    };

    // Handle ToggleBtn change
    const handleToggleChange = (isLimited) => {

        setIsLimitedBtn(isLimited);
        setFormData((prevData) => ({
            ...prevData,
            isLimited,
        }));
    };

    // Handle NumInput change
    const handleNumInputChange = (numOfSeats) => {

        setFormData((prevData) => ({
            ...prevData,
            numOfSeats,
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = await validateForm(formData); // Validate form data
        // Check if errors exist
        if (errors && Object.keys(errors).length > 0) {
            setErrors(errors);  // Directly set the errors object  // This will show the errors as an object
            return; // Stop submission if there are errors
        }


        const formDataToSend = new FormData();
        Object.keys(formData).forEach((key) => {
            formDataToSend.append(key, formData[key]);
        });

        try {
            const result = await dispatch(editSession({ eventId: formData.eventId, formData: formDataToSend })).unwrap();
            message.success('Update successfully!');
            setFormData({
                eventId: '',
                event_name: '',
                description: '',
                presenter: '',
                category: '',
                medium: '',
                date: null,
                startTime: '',
                endTime: '',
                files: null,
                status: '',
                event_status: '',
                isLimited: false,
                numOfSeats: 0,
                isCollection: false,
                eventCollectionId: ''
            })
            navigate('/admin/session/all') // Redirect to sessions page after successful submission
        } catch (err) {
            const errorMessage = err.error || 'Submission failed';
            message.error(errorMessage);
        }
    };


    const createEventCollection = async () => {
        setLoadingCollection(true)
        try {
            const res = await PrivateAxiosInstance.post(URLs.CREATE_EVENT_COLLECTION, submitCollectionData);
            const status = res.status
            if (status === 200) {
                message.success('Event collection created successfully')
                getCollections()
            }
        } catch (error) {
            const err = error?.response?.data?.error
            if (err) {
                message.error(err)
                console.error('Error creating event collection: ', err)
            } else {
                message.error('Error creating event collection')
                console.error('Error creating event collection: ', error)
            }
        } finally {
            setLoadingCollection(false)
        }
    }


    const getCollections = async (page = 1, limit = 10, search = '', sortBy = 'updatedAt', sortOrder = 'asc') => {
        setLoadingCollection(true);

        try {
            const res = await PrivateAxiosInstance.get(URLs.GET_EVENT_COLLECTIONS, {
                params: { page, limit, search, sortBy, sortOrder },
            });

            const status = res.status;
            if (status === 200) {
                const data = res?.data?.events;
                const page = res?.data?.total;
                setAllCollectionData(data || []);
                setTotalPages(page);
            }
        } catch (error) {
            console.error('Error fetching collections:', error);
        } finally {
            setLoadingCollection(false);
        }
    };

    useEffect(() => {
        getCollections(currentPage);
    }, [currentPage]);

    const handleCollectionToggleChange = (newValue) => {
        setIsCollectionSection(newValue);
        setFormData((prevData) => ({
            ...prevData,
            isCollection: newValue,
            eventCollectionId: newValue ? prevData.eventCollectionId : '', // Reset eventCollectionId if isCollection is false
        }));

        if (!newValue) {
            setSelectedCollectionId(''); // Reset the selected collection ID when isCollection is false
        }
    };

    const handleCollectionChange = (e) => {
        const { name, value } = e.target;
        setSubmitCollectionData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };


    return (
        <section
            className={`bg-background-primary-color mt-[30px] mb-[30px] 
        ${isComplate && isCollectionSection ? 'md:mt-[1000px] lg:mt-[800px] lg:mb-[1200px] md:mb-[1000px]' :
                    isComplate ? 'md:mt-[500px] lg:mt-[400px]' :
                        isCollectionSection ? 'md:mt-[600px] lg:mt-[600px]' :
                            'md:mt-[300px] lg:mt-[200px]'}
        lg:mb-[300px]`}
        >

            <Spin spinning={loading} fullscreen />

            <div className="flex flex-col items-center justify-center mx-auto md:h-screen lg:py-0">

                <div className="w-full bg-gray-800 rounded-lg shadow  md:min-w-[800px] lg:min-w-[1000px] md:mt-0 sm:max-w-md xl:p-0 ">

                    <div className="p-6 space-y-4 md:space-y-6 sm:p-8">

                        <h1 className="text-xl font-poppins font-bold leading-tight tracking-tight text-white md:text-2xl ">
                            Edit session
                        </h1>

                        <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6" >

                            <div className='w-full'>
                                <label htmlFor="small-input" className="font-poppins block mb-2 text-sm font-medium text-gray-300">Session ID</label>
                                <input
                                    value={formData.eventId}
                                    type='text'
                                    name='eventId'
                                    disabled
                                    className="font-poppins block w-[200px] p-2 cursor-not-allowed text-gray-900 border border-gray-300 rounded-lg bg-gray-50 text-sm dark:bg-gray-700 dark:border-gray-600 uppercase dark:placeholder-gray-400 dark:text-gray-400 dark:focus:ring-gray-400 dark:focus:border-gray-400" required></input>
                            </div>

                            {/* Title */}
                            <DataInputFeild
                                value={formData.event_name}
                                onChange={handleChange}
                                label={"Session Title"}
                                name={"event_name"}
                                type={"text"}
                                required={'required'}
                            />
                            {errors.event_name && <span className="text-red-500 text-xs">{errors.event_name}</span>}
                            {/* hoster */}
                            <DataInputFeild
                                value={formData.presenter}
                                onChange={handleChange}
                                label={"Presenter"}
                                name={"presenter"}
                                type={"text"}
                                required={'required'}
                            />
                            {errors.presenter && <span className="text-red-500 text-xs">{errors.presenter}</span>}

                            <div className="grid md:grid-cols-2 lg:grid-cols-4  md:gap-6">
                                {/* Error for Date */}
                                <div className="relative z-0 w-full mb-2 group">
                                    {/* Error space */}
                                    {/* date- must be a valid ISO 8601 date string */}
                                    <DatePickesr
                                        value={formData.date}
                                        onChange={handleDateChange}
                                    />
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.date || <>&nbsp;</>}
                                    </span>
                                </div>

                                {/* Error for Start Time and End Time */}
                                <div className="relative z-0 w-full mb-2 ml-[-40px] mt-3 sm:mt-0 sm:ml-[-20px] group">
                                    <div className="relative z-0 w-full mb-2 group ml-10">
                                        <label htmlFor="small-input" className="font-poppins block mb-2 text-sm font-medium text-gray-300">
                                            Select start and end time
                                        </label>
                                        <TimePicker
                                            value={[formData.startTime, formData.endTime]}  // Pass startTime and endTime from formData
                                            onChange={([startTime, endTime], [formattedStartTime, formattedEndTime]) => {
                                                setFormData((prevData) => ({
                                                    ...prevData,
                                                    startTime: formattedStartTime,  // Store formatted times
                                                    endTime: formattedEndTime,
                                                }));
                                            }}
                                        />
                                    </div>
                                    {/* Error space for start time */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.startTime || <>&nbsp;</>}
                                    </span>
                                    {/* Error space for end time */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.endTime || <>&nbsp;</>}
                                    </span>
                                </div>


                                <div className=" w-full mb-2 mt-4 lg:ml-20 lg:mt-0 group ">
                                    {/* toggle btn */}
                                    <ToggleBtn
                                        value={formData.isLimited}
                                        onChange={handleToggleChange}
                                        title={'Limited Seats'}
                                    />

                                    {/* Error for Status */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.isLimited || <>&nbsp;</>}
                                    </span>
                                </div>

                                <div className={`w-full mb-2 mt-4 lg:mt-0 group ${isLimitedBtn ? "" : "hidden"}`}>
                                    {/* number input */}
                                    <NumInput
                                        value={formData.numOfSeats}
                                        onChange={handleNumInputChange}
                                        status={isLimitedBtn}
                                    />
                                    {/* Error for Status */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.numOfSeats || <>&nbsp;</>}
                                    </span>
                                </div>


                            </div>


                            <div className="grid lg:grid-cols-4 md:grid-cols-2 md:gap-6">
                                {/* //FIX */}
                                <div className=" w-full mb-2 mt-4 lg:mt-0 group ">
                                    <StatusRb
                                        value={formData.event_status}
                                        onChange={handleEventStatusStatusChange}
                                    />

                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.event_status || <>&nbsp;</>}
                                    </span>
                                </div>

                                <div className=" w-full mb-2 mt-4 lg:mt-0 group ">
                                    {/* Status */}
                                    <RadioButton
                                        value={formData.status}
                                        onChange={handleStatusChange}
                                    />
                                    {/* Error for Status */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.status || <>&nbsp;</>}
                                    </span>
                                </div>

                                <div className="relative z-0 w-full mb-2 group mt-2 sm:mt-0">
                                    {/* Category */}
                                    <label htmlFor="small-input" className="font-poppins block mb-2 text-sm font-medium text-gray-300">Category</label>
                                    <Dropdown
                                        category={categoryOptions}
                                        value={formData.category}
                                        onChange={handleDropdownChange('category')}
                                        label={"Select a category"}
                                    />
                                    {/* Error for Category */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.category || <>&nbsp;</>}
                                    </span>
                                </div>

                                <div className="relative z-0 w-full group">
                                    {/* Language */}
                                    <label htmlFor="small-input" className="font-poppins block mb-2 text-sm font-medium text-gray-300">Language</label>
                                    <Dropdown
                                        value={formData.medium}
                                        onChange={handleDropdownChange('medium')}
                                        category={languageOptions}
                                        label={"Select a language"}
                                    />
                                    {/* Error for Language */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.medium || <>&nbsp;</>}
                                    </span>
                                </div>
                            </div>


                            {/* add to collection */}
                            <div className="grid md:grid-cols-3 md:gap-6 border border-gray-600 rounded-md p-2">


                                <div className="w-full mb-2 mt-4 lg:mt-0 group ">

                                    <ToggleBtn
                                        value={formData.isCollection}
                                        onChange={handleCollectionToggleChange}
                                        title={'Add to Collection'}
                                    />
                                    {/* Error for Status */}
                                    <span className="text-red-500 text-xs h-5 block">
                                        {errors.isCollection || <>&nbsp;</>}
                                    </span>
                                </div>

                                <div className={`col-span-2 flex flex-inline mr-3 ${isCollectionSection ? "" : "hidden"}`}>
                                    <DataInputFeild
                                        value={collectionData.eventCollectionName}
                                        onChange={handleCollectionChange}
                                        label={"Collection Title"}
                                        name={"eventCollectionName"}
                                        type={"text"}
                                    />
                                    {/* {errors.eventCollectionName && <span className="text-red-500 text-xs">{errors.eventCollectionName}</span>} */}

                                    <div className='flex justify-end item-center pl-3 '>
                                        <button
                                            onClick={createEventCollection}
                                            type="button"
                                            className=" font-poppins max-h-[40px] w-[80px] mt-7 text-white bg-gray-500 transition-all duration-300 hover:bg-gray-400 focus:ring-4 focus:outline-none focus:ring-gray-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-gray-600">Add
                                        </button>
                                    </div>


                                </div>

                            </div>

                            <div className={` ${isCollectionSection ? "" : "hidden"}`}>
                                {!loadingCollection ? (

                                    <Table
                                        collectionData={allCollectionData}
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onPageChange={handlePageChange}
                                        selectedCollectionId={selectedCollectionId}
                                        setSelectedCollectionId={(id) => {
                                            setSelectedCollectionId(id);
                                            setFormData((prevData) => ({
                                                ...prevData,
                                                eventCollectionId: id,
                                            }));
                                        }}
                                    />
                                ) : (
                                    <p>Loading...</p>
                                )}
                            </div>



                            {/* Description */}
                            <TextArea
                                value={formData.description}
                                onChange={handleChange}
                                label={"Description"}
                                name={'description'}
                                required={'required'}
                            />
                            <span className="text-red-500 text-xs h-5 block">
                                {errors.description || <>&nbsp;</>}
                            </span>

                            {/* Image uplaod */}
                            <div>
                                <label htmlFor="small-input" className="font-poppins block mb-1 text-sm font-medium text-gray-300pus">Upload cover image</label>
                                <FileuploadInput
                                    name={'files'}
                                    accept={'image/jpeg,image/png'}
                                    onChange={handleFileChange}
                                />
                            </div>


                            {/* Link uplaod */}

                            <div className="mt-2">
                                <label htmlFor="youtube-link" className="block font-poppins mb-2 text-sm font-medium text-gray-300">
                                    Add Session Link
                                </label>
                                {/* {error && <span className=" font-poppins text-sm text-red-600">{error}</span>} */}

                                <div className="relative mb-5   ">
                                    <div className="absolute inset-y-0 start-0 flex items-center pl-3 pointer-events-none">
                                        <IoLogoYoutube />
                                    </div>
                                    <input
                                        type="text"
                                        name="zoomLink"
                                        value={formData.zoomLink}
                                        onChange={handleChange}
                                        className=' bg-gray-50 border font-poppins border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white '
                                        // className={`bg-gray-50 border font-poppins border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white ${error ? 'border-red-500' : ''}`}
                                        placeholder="https://zoom.com/example"
                                    />
                                </div>


                            </div>

                            <div className='flex justify-end '>

                                {/* cancel Btn */}
                                <Link to={'/admin/session/all'}>
                                    <button
                                        type="button"
                                        className="font-poppins w-[100px] mr-3 text-white bg-gray-500 transition-all duration-300 hover:bg-gray-400 focus:ring-4 focus:outline-none focus:ring-gray-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-gray-600">Cancel
                                    </button>
                                </Link>
                                <button
                                    type="submit"
                                    className="font-poppins w-[100px]  text-black bg-btn-color transition-all duration-300 hover:bg-btn-hover-color focus:ring-4 focus:outline-none focus:ring-gray-600 font-medium rounded-lg text-sm px-5 py-2.5 text-center ">Update
                                </button>

                            </div>

                        </form>

                        {/* Border - below part uplaod video */}
                        <div className='w-full mt-3 border border-1 border-gray-600 '></div>

                        {isComplate &&

                            <>
                                {/* Mobile view select dropdown */}
                                <div className="sm:hidden">
                                    <label htmlFor="tabs" className="sr-only">Select your upload type</label>
                                    <select
                                        id="tabs"
                                        value={selectedTab}
                                        onChange={handleTabChange}
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    >
                                        <option value="video">Video Upload</option>
                                        <option value="youtube">YouTube Link</option>
                                    </select>
                                </div>

                                {/* Desktop view tabs */}
                                <ul className="hidden text-sm mt-5 font-medium text-center text-gray-500 rounded-lg shadow sm:flex dark:divide-gray-700 dark:text-gray-400">
                                    <li className="w-full rounded-lg mr-1">
                                        <a
                                            onClick={() => setSelectedTab("video")}
                                            className={`inline-block w-full font-poppins rounded-lg p-4 ${selectedTab === 'video' ? 'text-gray-900 bg-gray-100 dark:bg-gray-700 dark:text-white' : 'hover:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700'} border border-gray-200 dark:border-gray-500`}
                                        >
                                            Video Upload
                                        </a>
                                    </li>
                                    <li className="w-full rounded-lg ml-1">
                                        <a
                                            onClick={() => setSelectedTab("youtube")}
                                            className={`inline-block w-full rounded-lg  font-poppins p-4 ${selectedTab === 'youtube' ? 'text-gray-900 bg-gray-100 dark:bg-gray-700 dark:text-white' : 'hover:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700'} border dark:border-gray-500`}
                                        >
                                            YouTube Link
                                        </a>
                                    </li>
                                </ul>

                                {/* Conditional rendering based on selected tab */}
                                {selectedTab === "video" && (
                                    <div className="mt-5">
                                        <VideoUploadInput eventId={id} />
                                        {/* <FileuploadInput/> */}
                                    </div>
                                )}

                                {selectedTab === "youtube" && (
                                    <LinkInput eventId={id} link={url} />
                                )}
                            </>
                        }


                    </div>
                </div>
            </div>
        </section>

    );
}

export default EditSession;
